module.exports = __webpack_public_path__ + "static/media/17.131099d9.png";